// extracted by mini-css-extract-plugin
module.exports = {"black":"#212121","filter":"SelectDropdown_filter__2zvRl"};